import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "formKitWrap fillSheet" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "loader" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "center" }, "病院の追加", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "note" }, "ひらがなで入力してください。スペース(空白)は入力することができません。", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "note" }, "不明な場合: 「ご担当者」と入力してください", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "note" }, "不明な場合: 「ごたんとうしゃ」と入力してください", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "note" }, "ひらがなで入力してください。スペース(空白)は入力することができません。", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "note" }, "ハイフンは不要です。半角数字で入力してください。", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "note" }, "ハイフンは不要です。半角数字で入力してください。", -1)
const _hoisted_10 = {
  key: 0,
  type: "info",
  class: "note"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "note" }, "必須の項目です", -1)
const _hoisted_12 = ["value"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "note" }, "擬似的な求人を作成し、掲載します。", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("option", { value: "false" }, "いいえ", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("option", { value: "true" }, "はい", -1)
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/_createTextVNode("登録する")
const _hoisted_18 = /*#__PURE__*/_createElementVNode("b", null, "パスワードは二度と表示されません。必ずメモしてください。", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_22 = /*#__PURE__*/_createTextVNode("完了")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_collapse_transition = _resolveComponent("n-collapse-transition")!
  const _component_n_alert = _resolveComponent("n-alert")!
  const _component_n_input = _resolveComponent("n-input")!
  const _component_n_form_item = _resolveComponent("n-form-item")!
  const _component_n_form = _resolveComponent("n-form")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_space = _resolveComponent("n-space")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_n_collapse_transition, { show: _ctx.totalLoading }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_n_collapse_transition, {
      class: "formKit",
      show: !_ctx.totalLoading
    }, {
      default: _withCtx(() => [
        (_ctx.err)
          ? (_openBlock(), _createBlock(_component_n_alert, {
              key: 0,
              title: "失敗しました",
              type: "error",
              closable: "",
              style: {"margin-bottom":"10px"}
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.err), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _hoisted_3,
        _createVNode(_component_n_form, {
          model: _ctx.model,
          ref: "formRef",
          rules: _ctx.rules
        }, {
          default: _withCtx(() => [
            _createVNode(_component_n_form_item, {
              path: "email",
              label: "メールアドレス"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_n_input, {
                  value: _ctx.model.email,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model.email) = $event)),
                  placeholder: " ",
                  "input-props": { autocomplete: 'email' }
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_n_form_item, {
              path: "name",
              label: "病院名(法人名)"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_n_input, {
                  value: _ctx.model.name,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.model.name) = $event)),
                  placeholder: " "
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_n_form_item, {
              path: "furigana",
              label: "ふりがな"
            }, {
              default: _withCtx(() => [
                _hoisted_4,
                _createVNode(_component_n_input, {
                  value: _ctx.model.furigana,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.model.furigana) = $event)),
                  placeholder: " "
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_n_form_item, {
              path: "personName",
              label: "ご担当者様氏名"
            }, {
              default: _withCtx(() => [
                _hoisted_5,
                _createVNode(_component_n_input, {
                  value: _ctx.model.personName,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.model.personName) = $event)),
                  placeholder: " "
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_n_form_item, {
              path: "personNameFurigana",
              label: "ご担当者様氏名ふりがな"
            }, {
              default: _withCtx(() => [
                _hoisted_6,
                _hoisted_7,
                _createVNode(_component_n_input, {
                  value: _ctx.model.personNameFurigana,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.model.personNameFurigana) = $event)),
                  placeholder: " "
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_n_form_item, {
              path: "tel",
              label: "電話番号"
            }, {
              default: _withCtx(() => [
                _hoisted_8,
                _createVNode(_component_n_input, {
                  value: _ctx.model.tel,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.model.tel) = $event)),
                  placeholder: " ",
                  type: "tel"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_n_form_item, {
              path: "postcode",
              label: "郵便番号"
            }, {
              default: _withCtx(() => [
                _hoisted_9,
                _createVNode(_component_n_input, {
                  value: _ctx.model.postcode,
                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.model.postcode) = $event)),
                  placeholder: " ",
                  onChange: _ctx.postcodeToAddress
                }, null, 8, ["value", "onChange"])
              ]),
              _: 1
            }),
            _createVNode(_component_n_form_item, {
              path: "addressDetails",
              label: "住所"
            }, {
              default: _withCtx(() => [
                (_ctx.addressLoading)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_10, "郵便番号から住所を検索しています"))
                  : _createCommentVNode("", true),
                _createVNode(_component_n_input, {
                  value: _ctx.model.addressDetails,
                  "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.model.addressDetails) = $event)),
                  placeholder: " "
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_n_form_item, { label: "業種" }, {
              default: _withCtx(() => [
                _hoisted_11,
                _withDirectives(_createElementVNode("select", {
                  class: "n-input-like",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.model.type) = $event))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bt, (w) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: w.value,
                      value: w.value
                    }, _toDisplayString(w.label), 9, _hoisted_12))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.model.type]
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_n_form_item, { label: "応募を作成する" }, {
              default: _withCtx(() => [
                _hoisted_13,
                _withDirectives(_createElementVNode("select", {
                  class: "n-input-like",
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.model.addApply) = $event))
                }, _hoisted_16, 512), [
                  [_vModelSelect, _ctx.model.addApply]
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"]),
        _createVNode(_component_n_space, { justify: "center" }, {
          default: _withCtx(() => [
            _createVNode(_component_n_button, {
              type: "primary",
              onClick: _ctx.post,
              loading: _ctx.loading
            }, {
              default: _withCtx(() => [
                _hoisted_17
              ]),
              _: 1
            }, 8, ["onClick", "loading"])
          ]),
          _: 1
        }),
        (_ctx.password)
          ? (_openBlock(), _createBlock(_component_n_alert, {
              key: 1,
              title: "登録が完了しました。",
              type: "info",
              closable: "",
              style: {"margin-bottom":"10px"}
            }, {
              default: _withCtx(() => [
                _hoisted_18,
                _hoisted_19,
                _createTextVNode(" " + _toDisplayString(_ctx.email), 1),
                _hoisted_20,
                _createTextVNode(" " + _toDisplayString(_ctx.password), 1),
                _hoisted_21,
                _createVNode(_component_n_button, {
                  type: "primary",
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$router.push('/admin/hospital')))
                }, {
                  default: _withCtx(() => [
                    _hoisted_22
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}